module.exports = new __parcel__URL__("shop_machines_christmas_tree_2023.a452ad6a.png").toString();